<script setup lang="ts">
import { Badge } from '@vue-interface/badge';
import { type BadgeDescription } from 'types';
import { titleCase } from '../../composables/titleCase';

defineProps<{
    description: BadgeDescription
}>();
</script>

<template>
    <Badge
        size="badge-xs"
        :class="{
            'badge-neutral-500': description.color === 'neutral',
            'badge-amber-500': description.color === 'amber',
            'badge-green-500': description.color === 'green',
            'badge-blue-500': description.color === 'blue',
            'badge-red-500': description.color === 'red',
        }">
        {{ titleCase(description.text) }}
    </Badge>
</template>